"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDialogAction = exports.default = void 0;
var SimpleDialog_1 = require("./SimpleDialog");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(SimpleDialog_1).default; } });
var SimpleDialogAction_1 = require("./SimpleDialogAction");
Object.defineProperty(exports, "SimpleDialogAction", { enumerable: true, get: function () { return __importDefault(SimpleDialogAction_1).default; } });
//# sourceMappingURL=index.js.map